import { createReducer } from "@reduxjs/toolkit";
import type { ProcessingState } from "@redux/state/shared-types";
import { changeTrainingFollowUpEndDate, resetChangeTrainingFollowUpEndDate } from "./change-training-follow-up-end-date";

const initialState: ProcessingState = { processing: "idle" };

export const changeTrainingFollowUpEndDateReducer = createReducer<ProcessingState>(initialState, builder => {
  builder.addCase(changeTrainingFollowUpEndDate.fulfilled, state => {
    return {
      ...state,
      processing: "success",
    };
  });
  builder.addCase(changeTrainingFollowUpEndDate.pending, state => {
    return {
      ...state,
      processing: "pending",
    };
  });
  builder.addCase(changeTrainingFollowUpEndDate.rejected, state => {
    return {
      ...state,
      processing: "failed",
    };
  });
  builder.addCase(resetChangeTrainingFollowUpEndDate, () => {
    return initialState;
  });
});
